import axios from 'axios'

export function getIssuesForUser(userId: string) {
  const url = `/api/v3/issues/all/`
  return axios.get(url, { params: { user_id: userId } }).then((response) => {
    return response.data
  })
}
